import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartScatter } from './useGetChartScatter'
import { ChartScatterContent } from './ChartScatterContent'

export const ChartScatterComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartScatter(id, tileFilterSelections)

  return (
    <ChartScatterContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartScatterComponentLoading() {
  return 'Loading...'
}
